<!-- <section *ngIf="!processing" class="matero-card width-100">
    <div fxLayout="row" fxLayoutAlign="center center">
        <h2>Plumber Treatments {{partnerId}}</h2>
    </div>
</section> -->

<section [hidden]="!processing">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" aria-label="Loading..."></mat-progress-bar>
</section>

<form #form="ngForm" [formGroup]="treatmentForm" class="form-field-full width-100">
    <div class="matero-card width-100" fxLayout="column" fxFlex="100" fxFlex.lt-sm="100">
        <mat-card fxFlex="100" class="matero-card width-100">
            <div fxLayout="row" fxLayoutGap="8px grid" fxFlex="100" fxFlex.lt-sm="100" fxLayout.lt-sm="column">
                <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                    <mat-form-field appearance="standard" class="width-100" style="width:100%;">
                        <mat-label>Pending Treatments ({{pendingTreatments.length}})</mat-label>
                        <input type="text" placeholder="Search Pending Treatments" aria-label="Pending Treatments" matInput [formControl]="pendingTreatmentsControl" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let item of filteredPendingTreatments | async" [value]="item.address" (onSelectionChange)="loadTreatment(item.treatmentId)">
                                {{item.address}}, {{item.city}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                    <mat-form-field appearance="standard" class="width-100" style="width:100%;">
                        <mat-label>Completed Treatments ({{completedTreatments.length}})</mat-label>
                        <input type="text" placeholder="Search Completed Treatments" aria-label="Completed Treatments" matInput [formControl]="completedTreatmentsControl" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let item of filteredCompletedTreatments | async" [value]="item.address" (onSelectionChange)="loadTreatment(item.treatmentId)">
                                {{item.address}}, {{item.city}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </mat-card>
    </div>
    <div class="divider"></div>

    <div class="matero-card width-100" fxLayout="column" fxFlex="100" fxFlex.lt-sm="100" *ngIf="partnerTreatment && partnerTreatment.treatmentId" @fadeIn>
        <div fxFlex="100" fxFlex.lt-sm="100">
            <mat-card id="partnerInfo">
                <div fxLayout="row wrap">
                    <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Housing Unit Address</strong><br />{{partnerTreatment.address}} {{partnerTreatment.city}}
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Housing Unit County</strong><br />{{partnerTreatment.county}}
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Housing Unit Mailing Address</strong><br />{{partnerTreatment.mailingAddress}} {{partnerTreatment.mailingCity}},{{partnerTreatment.mailingState}}
                        {{partnerTreatment.mailingZip}}
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Shared Well</strong><br />
                        <span *ngIf="partnerTreatment.sharedWell">Yes</span>
                        <span *ngIf="!partnerTreatment.sharedWell">No</span>
                    </div>
                </div>
                <div fxLayout="row wrap">
                    <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Date of First Tier 3 Sample</strong><br />
                        {{partnerTreatment.treatmentData.dateOfFirstTier3Sample != null ? partnerTreatment.treatmentData.dateOfFirstTier3Sample : '-'}}
                    </div>
                    <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Highest Nitrate Test Result (mg/L)</strong><br />
                        {{ partnerTreatment.treatmentData.highestNitrateTestResult != null ? partnerTreatment.treatmentData.highestNitrateTestResult : '-' }}
                    </div>
                    <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Date of Highest Nitrate Result</strong><br />
                        {{partnerTreatment.treatmentData.dateOfHighestNitrateResult != null ? partnerTreatment.treatmentData.dateOfHighestNitrateResult : '-'}}
                    </div>
                    <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col pad-10">
                        <strong>Last Sample Collection Date</strong><br />
                        {{partnerTreatment.treatmentData.lastSampleCollectionDate != null ? partnerTreatment.treatmentData.lastSampleCollectionDate : '-'}}
                    </div>
                </div>
            </mat-card>

            <mat-card>
                <div fxLayout="row wrap">
                    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                        <mat-form-field appearance="outline">
                            <mat-label>Status of Install</mat-label>
                            <mat-select id="statusOfInstall" name="statusOfInstall" formControlName="statusOfInstall">
                                <mat-option value=""> -select- </mat-option>
                                <mat-option *ngFor="let item of housingUnitService.statusOfInstallOptions" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                        <mat-form-field appearance="outline">
                            <mat-label>Treatment Install Completion Date</mat-label>
                            <input id="treatmentInstallCompletionDate" name="treatmentInstallCompletionDate" formControlName="treatmentInstallCompletionDate" placeholder="mm/dd/yyyy" matInput
                                [matDatepicker]="datepickerTreatmentInstallCompletionDate" autocomplete="off" />
                            <mat-datepicker-toggle matSuffix [for]="datepickerTreatmentInstallCompletionDate"></mat-datepicker-toggle>
                            <mat-datepicker #datepickerTreatmentInstallCompletionDate>
                                <mat-datepicker-actions>
                                    <button mat-raised-button color="primary" matDatepickerApply>
                                        Apply
                                    </button>
                                    <button mat-button matDatepickerCancel>Cancel</button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row wrap">
                    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                        <mat-form-field appearance="outline">
                            <mat-label>Installed by</mat-label>
                            <mat-select id="installedBy" name="installedBy" formControlName="installedBy">
                                <mat-option value=""> -select- </mat-option>
                                <mat-option *ngFor="let item of housingUnitService.installedByOptions" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                        <mat-form-field appearance="outline">
                            <mat-label>OHA System Installed</mat-label>
                            <mat-select id="systemInstalled" name="systemInstalled" formControlName="systemInstalled">
                                <mat-option value=""> -select- </mat-option>
                                <mat-option *ngFor="let item of housingUnitService.systemInstalledOptions" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayoutAlign="start center">
                    <button mat-raised-button color="primary" (click)="submitTreatment()" [disabled]="processing">Submit Treatment</button>
                </div>

            </mat-card>
        </div>
    </div>

</form>